import script from "./DataGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./DataGrid.vue?vue&type=script&setup=true&lang=js"

import "./DataGrid.vue?vue&type=style&index=0&id=eb3ffd30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb3ffd30"]])

export default __exports__